import styles from "../../assets/css/customSignup.module.scss";
import AppSkeleton from "../../components/Skeletons/AppSkeleton";
import ForwardArrow from "../../components/svgs/ForwardArrow";
import { baseColor, highlightColor } from "../../constants/skeletonColor";
import { remittanceRateCardClicked } from "../../libs/events";

const CrickBuzzFxCard = ({
  isFetchingRate,
  display_base_fx,
  display_promo_fx,
}) => {
  const handleSendMoney = () => {
    localStorage.setItem("token", "");
    remittanceRateCardClicked({ source: "crickbuzz_signup_success" });
    window.open(
      `${process.env.REACT_APP_TC_URL}/getapp/login?type=mobile&source=remittance&utm_source=crickbuzz`
    );
  };
  return (
    <div className={styles.crickBuzzFxCard}>
      <div>
        <img
          src={
            "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/cricbuzz/sendMoney.svg"
          }
          alt="money"
        />
      </div>
      <div className={styles.rightSection}>
        <div>
          <div className={styles.sendMoneyText}>Send money to India at</div>
          <div className={`${styles.sendMoneyText} ${styles.rateText}`}>
            the Best FX Rate*
          </div>
          <div className={styles.rateBox}>
            <span className={styles.highlighted}>$1 =</span>
            {isFetchingRate ? (
              <span>
                <AppSkeleton
                  height={24}
                  width={72}
                  baseColor={baseColor}
                  highlightColor={highlightColor}
                  className={styles.fxSkeleton}
                />
              </span>
            ) : (
              <>
                <span className={styles.striked}>{display_base_fx}</span>
                <span className={styles.highlighted}>{display_promo_fx}</span>
              </>
            )}
          </div>
        </div>
        <div>
          <div className={styles.sendMoney} onClick={handleSendMoney}>
            <div>Send Money Now</div>
            <div className={styles.arrow}>
              <ForwardArrow height="12" width="12" color="#FFD866" />
            </div>
          </div>
          <div className={styles.noAppDownlaodText}>
            *No app download required
          </div>
        </div>
      </div>
    </div>
  );
};
export default CrickBuzzFxCard;
